import styled, { css, keyframes } from "styled-components";

// Definindo a animação de piscar
const blinkAnimation = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;
const animationIntroduction = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const MotoBombaStyled = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  max-width: 100%;
  background: rgb(107, 107, 107);
  background: linear-gradient(
    180deg,
    rgba(107, 107, 107, 1) 0%,
    rgba(186, 186, 186, 1) 100%
  );
  section {
    display: flex;
    gap: 25%;
    width: 100%;
    max-width: 100%;
    height: fit-content;
    min-height: 100vh;
    margin-top: 20px;
    margin-bottom: 30px;
    .conteiner {
      width: 100%;
      max-width: 94%;
      height: 100%;
      display: flex;
      flex-direction: column;
      gap: 25px;
      list-style: none;
      margin-left: 90px;
      .motoBomba {
        display: flex;
        flex-direction: column;
        width: 100%;
        /* min-height: 95vh; */
        max-width: 100%;
        padding: 25px;
        background: rgb(107, 107, 107);
        background: linear-gradient(
          0deg,
          rgba(107, 107, 107, 0.8) 0%,
          rgba(186, 186, 186, 0.8) 100%
        );
        max-height: 100px;
        overflow: hidden;
        border-radius: 5px;
        position: relative;
        gap: 25px;
        .alertas {
          font-size: 45px;
          position: absolute;
          right: 25px;
          color: rgba(50, 50, 50, 0.9);
          cursor: pointer;
          transition: 0.5s;
        }
        .alertas:hover {
          color: rgba(50, 50, 50, 1);
        }
        .nomeMotoBomba {
          display: flex;
          align-items: center;
          gap: 15px;
          cursor: pointer;
          img {
            width: 60px;
            opacity: 60%;
          }
          h2 {
            color: rgba(203, 203, 203, 1);
            font-size: 24px;
          }
        }
        .controles {
          h3 {
            color: rgba(50, 50, 50, 0.81);
            font-size: 30px;
          }
          ul {
            list-style: none;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            gap: 25px;
            margin-top: 20px;
            li {
              .ControleAnimation {
                display: flex;
                flex-direction: column;
                gap: 10px;
                align-items: center;
                width: fit-content;
                max-width: 100%;

                p {
                  color: rgba(236, 236, 236, 1);
                  font-size: 18px;
                }
                .desativado {
                  opacity: 30%;
                  cursor: no-drop;
                  .buttonSelect {
                    cursor: no-drop;
                  }
                  .bunttonConfirmation {
                    cursor: no-drop;
                  }
                  .buttonPower {
                    cursor: no-drop;
                  }
                }
                div {
                  display: flex;
                  align-items: center;
                  gap: 10px;
                  background-color: rgba(0, 0, 0, 0.3);
                  padding: 10px;
                  border-radius: 5px;
                  border: 2px solid rgba(139, 139, 139, 1);
                  background: rgb(140, 140, 140);
                  height: 60px;
                  transition: 1s;
                  span {
                    color: rgba(237, 237, 237, 1);
                  }
                  .buttonSelect {
                    width: 42px;
                    min-width: 40px;
                    height: 22px;
                    border-radius: 50px;
                    border: none;
                    position: relative;
                    cursor: pointer;
                    background: white;
                  }
                  .bunttonConfirmation {
                    padding: 8px 10px;
                    height: 32px;
                    border-radius: 10px;
                    border: 1px solid transparent;
                    font-size: 16px;
                    cursor: pointer;
                    background-color: rgba(230, 230, 230, 1);
                    transition: 0.5s;
                  }
                  .bunttonConfirmation:hover {
                    border: 1px solid rgba(111, 111, 111, 1);
                  }
                  .buttonPower {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 5px;
                    padding: 0px 10px;
                    height: 32px;
                    border-radius: 10px;
                    border: 1px solid transparent;
                    font-size: 16px;
                    cursor: pointer;
                    background-color: rgba(230, 230, 230, 1);
                    transition: 0.5s;
                    width: 120px;
                    max-width: 100%;
                  }

                  input {
                    font-size: 15px;
                    background-color: rgba(230, 230, 230, 1);
                    border-radius: 10px;
                    border: none;
                    width: 100px;
                    height: 35px;
                    color: rgba(31, 31, 31, 1);
                    max-width: 100%;
                    padding-left: 10px;
                  }
                }
              }
            }
          }
        }
      }
      .expanded {
        max-height: 100%;
        min-height: 95vh;
        overflow: none;
      }
    }
  }
  @media (max-width: 850px) {
    section {
      justify-content: end;
      .conteiner {
        width: 85%;
        margin-left: 0px;
        /* background-color: red; */
        .motoBomba {
          width: 100%;
          overflow: auto;
          padding: 15px;
        }
      }
    }
  }
`;

export const DadosMotoBombaStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  h3 {
    color: rgba(50, 50, 50, 0.81);
    font-size: 30px;
  }
  ul {
    list-style: none;
    display: flex;
    gap: 25px;
    flex-wrap: wrap;
    margin-bottom: 30px;
    .dados {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 10px;
      position: relative;
      p {
        color: rgba(236, 236, 236, 1);
        font-size: 18px;
      }
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: 100%;
        min-width: 100px;
        background-color: rgba(0, 0, 0, 0.15);
        color: rgba(237, 237, 237, 1);
        padding: 15px 10px;
        border-radius: 10px;
      }
      .alertaBateria {
        width: 200px;
        position: absolute;
        right: -30px;
        top: 40px;
        display: flex;
        /* background-color: red; */
        align-items: center;
        justify-content: space-between;

        .icon {
          color: rgba(255, 210, 0, 0.59);
          font-size: 35px;
          cursor: pointer;
          animation: ${blinkAnimation} 3s infinite;
        }
        p {
          display: none;
          background-color: rgba(0, 0, 0, 0.8);
          padding: 8px;
          z-index: 2;
          border-radius: 15px;
        }
      }
      .alertaBateria:hover > p {
        display: block;
        animation: ${animationIntroduction} 1s;
      }
    }
    .dadosBarra {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: first baseline;
      gap: 10px;
      p {
        color: rgba(236, 236, 236, 1);
        font-size: 18px;
      }
      .conteinerTemperatura {
        width: 180px;
        height: 80px;
        /* background-color: aquamarine; */
      }
    }
  }
`;

export const Dot = styled.span`
  position: absolute;
  background: rgba(0, 0, 0, 1);
  width: 20px;
  height: 20px;
  border-radius: 50%;
  top: 1px;
  transition: 0.5s;
  ${({ isLeft }) =>
    isLeft
      ? css`
          left: 2px;
        `
      : css`
          left: 19px;
        `}
`;
